module.exports = __webpack_public_path__ + "media/images/checkout/mastercard-0c5967c9e987faa16d9f6a6e59a3d96c.png";